<template>
  <Modal v-model="batchFillConfigurationModal" :title="$t('key1001272')" width="600" :transfer="false"
    :mask-closable="false" @on-visible-change="batchFillConfigurationChange">
    <div class="flex align-items-center mb20">
      <span>{{ $t('key1001273') }}</span>
      <RadioGroup v-model="fillModeType">
        <Radio class="mr30" label="skuConfig">{{ $t('key1001274') }}</Radio>
        <Radio label="skuSpecificationConfig">{{ $t('key1001275') }}</Radio>
      </RadioGroup>
    </div>
    <div class="flex align-items-center mb20" v-if="fillModeType === 'skuSpecificationConfig'">
      <span>{{ $t('key1001276') }}</span>
      <RadioGroup v-model="specificationsValue">
        <Radio class="mr30" v-for="item in specificationsList" :label="item.label">{{ item.label }}</Radio>
      </RadioGroup>
    </div>
    <p class="color-999 font-size-13">{{ fillModeTypeText }}</p>
    <template #footer>
      <Button @click="batchFillConfigurationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="batchFillConfigurationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {saveErpCommonSettingParam} from "@/utils/common";
import {YMS_MERCHANT_CONFIG_KEY_MAP} from "@/utils/enum";

export default {
  name: 'batchFillConfigurationModal',
  mixins: [Mixin],
  props: {
    specificationsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    fillConfig: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ymsProductCategoryId: {
      type: String,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      batchFillConfigurationModal: false,
      fillModeType: 'skuConfig',
      specificationsValue: null,
      paramKey: null,
    };
  },
  computed: {
    fillModeTypeText() {
      return this.fillModeType === 'skuConfig' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001270') :
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001271');
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initFillConfigurationData(key) {
      this.paramKey = YMS_MERCHANT_CONFIG_KEY_MAP[key] || '';
      // 默认值
      this.fillModeType = 'skuConfig';
      this.specificationsValue = null;
      if (this.paramKey && Array.isArray(this.fillConfig) && this.fillConfig.length > 0) {
        const targetConfig = this.fillConfig.find(item => item.paramKey === this.paramKey);
        if (targetConfig) {
          this.fillModeType = targetConfig.fillModeType || 'skuConfig';
          this.specificationsValue = targetConfig.specificationsValue || null;
        }
      }
      this.batchFillConfigurationModal = true;
    },
    // 确定
    batchFillConfigurationBtn() {
      let obj = {
        fillModeType: this.fillModeType,
        specificationsValue: this.specificationsValue,
        paramKey: this.paramKey
      };
      let query = [
        {
          paramKey: this.paramKey,
          paramValue: JSON.stringify(obj),
          businessId: this.userInfo.merchantId + '*' + this.ymsProductCategoryId
        }
      ];
      saveErpCommonSettingParam(query).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
        this.batchFillConfigurationModal = false;
        this.$emit('updateFillConfigData', this.ymsProductCategoryId);
      });
    },
    // 监听弹窗
    batchFillConfigurationChange(value) {
      if (!value) {
        this.fillModeType = 'skuConfig';
        this.specificationsValue = null;
      }
    }
  },
  watch: {
    fillModeType: {
      handler(value) {
        if (value === 'skuSpecificationConfig' && !this.specificationsValue) {
          this.specificationsValue = this.specificationsList.length > 0 ? this.specificationsList[0].label : null;
        }
      },
      immediate: true,
      deep: true
    }
  },
};
</script>

<style lang="less">

</style>
